import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import api from "../../services/api";
import { store } from 'react-notifications-component';
import { theme } from '../../styles/theme';

import Input from "../../components/input/input_v2";
import NumericBox from '../../components/numeric-box';
import Button from "../../components/button/button_v2";
import GenericUpper from '../../components/generic-upper';
import ModalGeneric from '../../components/modal/modalGeneric';

import {
    Container,
    ModalWide,
    Title,
    ModalStack,
    ModalIntro,
    NewValueSummary,
    CompareTable,
    CompareHeaderRow,
    CompareRow,
    CompareLabel,
    NumericBoxWrapper,
    DeltaQty,
    DeltaValue,
    ProrationNote,
    ModalButtonsRow,
} from './styles';

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const EditarPlano = ({ ...props }) => {
    const [contrato, setContrato] = useState([]);
    const [plano, setPlano] = useState([]);
    const [showNewUser, setShowNewUser] = useState(false);
    const [newQtdUsers, setNewQtdUsers] = useState(0);
    const [loading, setLoading] = useState(false);
    const [simulacao, setSimulacao] = useState(null);
    const [simulando, setSimulando] = useState(false);
    const [erroSimulacao, setErroSimulacao] = useState('');
    const [showNoUpdate, setShowNoUpdate] = useState(false);
    // "Usuários (X/Y)" do modal - busca direto na mesma rota que a tela Usuários usa
    // (GET /users/qtd-licencas), ao abrir o modal, em vez de confiar no que /planos
    // devolve - evita qualquer divergência entre as duas telas.
    const [usuariosCadastrados, setUsuariosCadastrados] = useState(null);

    const formatBRL = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    // plan_value pode estar gravado como "799,60" ou "799.60" - parseFloat("799,60") perderia os centavos
    const parseValorBR = (valor) => {
        let texto = String(valor ?? '').trim();
        if (texto.includes(',')) {
            texto = texto.replace(/\./g, '').replace(',', '.');
        }
        const numero = Number(texto);
        return Number.isNaN(numero) ? 0 : numero;
    };

    const getPlano = async () => {
        try {
            const response = await api.get('/planos');

            setContrato(response.data.data?.contrato);
            setPlano(response.data.data?.plano);
        } catch (error) {}
    }

    // O PUT /planos/licencas rejeita (ERRO-390) contratos sem assinatura ligada ao gateway
    // de pagamento - sem essa checagem aqui, o usuário preenchia todo o simulador de
    // licenças e só descobria isso ao clicar em CONFIRMAR, no fim do fluxo.
    const addNew = () => {
        if (contrato?.possui_assinatura === false) {
            store.addNotification({
                title: "Erro!",
                message: "ERRO-390 Este contrato não possui uma assinatura ativa no gateway de pagamento - Entre em contato com o suporte.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });
            return;
        }
        // Mesma rota e mesmo campo que a tela Usuários usa pro "Quantidade de usuários
        // do seu plano: X/Y" - busca de novo aqui, toda vez que o modal abre, em vez de
        // reaproveitar algo vindo de /planos.
        api.get('/users/qtd-licencas')
            .then((response) => setUsuariosCadastrados(response.data?.usuarios_cadastrados ?? null))
            .catch(() => setUsuariosCadastrados(null));
        setShowNewUser(true);
    }

    const update = async () => {
        setLoading(true);

        try {
            // O valor é calculado no backend (mesma regra da simulação exibida)
            const payload = {
                qtd_total_licencas: Number(newQtdUsers)
            }

            const response = await api.put('/planos/licencas', payload);

            if (response) {
                store.addNotification({
                    title: "Sucesso!",
                    message: "Licença(s) atualizada(s) com sucesso!",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                setShowNewUser(false);
                getPlano();
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            setShowNewUser(false);
        }
    }

    useEffect(() => {
        getPlano();
    }, [])

    useEffect(() => {
        if (showNewUser === false) {
            setNewQtdUsers(0);
            setSimulacao(null);
            setSimulando(false);
            setErroSimulacao('');
            setLoading(false);
            setUsuariosCadastrados(null);
        }
    }, [showNewUser])

    // Valor por usuário já pago pelo cliente (ou tabela, se não houver assinatura) - calculado no backend
    useEffect(() => {
        const qtd = Number(newQtdUsers);

        if (!showNewUser || !qtd) return;

        let cancelado = false;
        setSimulando(true);

        const timer = setTimeout(async () => {
            try {
                const response = await api.get('/planos/licencas/simulacao', { params: { qtd } });

                if (!cancelado) {
                    setSimulacao(response.data.data);
                    setErroSimulacao('');
                }
            } catch (error) {
                if (!cancelado) {
                    setSimulacao(null);
                    setErroSimulacao(identifyErrorMenssage(error));
                }
            } finally {
                if (!cancelado) setSimulando(false);
            }
        }, 300);

        return () => {
            cancelado = true;
            clearTimeout(timer);
        };
    }, [newQtdUsers, showNewUser])

    useEffect(() => {
        if (plano?.length !== 0) {
            if (plano?.plans?.nivel <= 3) {
                setShowNoUpdate(true);
            }
        }
    }, [plano])

    const qtdAtual = parseInt(contrato?.qtd_adquirida) || 0;
    // Duas contagens diferentes de "licença em uso" (o backend valida a redução
    // contra as duas - ver editUser em plans.service.ts, nunca só uma):
    // - agronomosEmUso: responsáveis técnicos cadastrados e ativos - usa
    //   contrato.usuarios_em_uso (não tecnicos_em_uso, que conta só na subsidiária
    //   direta do login e fica abaixo do real; usuarios_em_uso bateu com a tela de
    //   Responsáveis Técnicos quando conferido).
    // - usuariosEmUso: logins ativos do contrato (exceto Master).
    // O mínimo de licenças é o maior dos dois - reduzir abaixo disso o backend rejeita.
    const agronomosEmUso = parseInt(contrato?.usuarios_em_uso) || 0;
    const usuariosEmUso = usuariosCadastrados !== null
        ? parseInt(usuariosCadastrados) || 0
        : parseInt(contrato?.usuarios_em_uso) || 0;
    const minLicencas = Math.max(agronomosEmUso, usuariosEmUso);
    const qtdNova = Number(newQtdUsers) || 0;
    const deltaQtd = qtdNova - qtdAtual;

    // Valores vindos da simulação do backend (mesmo cálculo usado ao confirmar), exibidos
    // no ciclo do plano: plano anual mostra valores por ano, mensal por mês.
    const sufixoCiclo = simulacao?.renew_type_id === 4 ? '/ano' : simulacao?.renew_type_id === 3 ? '/semestre' : '/mês';
    const formataDelta = (delta) => {
        const sinal = delta > 0 ? '+' : delta < 0 ? '-' : '';
        return `${sinal}${formatBRL(Math.abs(delta))}`;
    };
    const deltaTexto = simulacao ? `${formataDelta(simulacao.diferenca)}${sufixoCiclo}` : '-';

    return (
        <>
            <GenericUpper
                align="center"
                title="Meu plano"
                subtitle="Configurações do plano atual"
            />

            <Container>
                {contrato?.length !== 0 && plano?.length !== 0 ? (
                    <>
                        <Input
                            id="plano"
                            label="Plano"
                            value={plano?.plans?.plan_name}
                            disabled={true}
                        />
                        
                        <Input
                            id="valor"
                            label="Valor"
                            value={formatBRL(parseValorBR(plano?.plan_value))}
                            unidade={plano?.agro_plans_renew_types?.descricao}
                            disabled={true}
                            addNew={false}

                        />
                        
                        <Input
                            id="licencas"
                            label="Total de Licenças"
                            value={contrato?.qtd_adquirida}
                            addNew={plano?.plan?.nivel <= 3 ? false : true}
                            onClickAddNew={() => addNew()}
                            isMobile={props.isMobile}
                            disabled={plano?.plan?.nivel <= 3 ? true : false}
                        />
                    </>
                ) : (
                    <></>
                )}


            </Container>

            <ModalGeneric
                show={showNewUser}
                onHide={() => setShowNewUser(false)}
                size='md'
                width='560px'
            >
                <ModalWide marginTop="0px">
                    <ModalStack>
                        <Title marginBottom='0px'>
                            Adicionar ou alterar licenças
                        </Title>

                        <ModalIntro>
                            Confira o valor que será acrescentado antes de confirmar
                        </ModalIntro>

                        <CompareTable>
                            <CompareHeaderRow>
                                <span>Licenças atuais</span>
                                <span>Licenças ajustadas</span>
                                <span>Alteração no valor</span>
                            </CompareHeaderRow>

                            <CompareRow>
                                <CompareLabel bold>
                                    {qtdAtual} {qtdAtual === 1 ? 'licença' : 'licenças'}
                                    {simulacao?.origem === 'CONTRATO' && (
                                        <small>{formatBRL(simulacao.valor_atual)}{sufixoCiclo}</small>
                                    )}
                                </CompareLabel>

                                <NumericBoxWrapper>
                                    <NumericBox
                                        initialValue={contrato.qtd_adquirida}
                                        allowNegative={false}
                                        allowEmpty={false}
                                        min={minLicencas}
                                        onChange={(e) => setNewQtdUsers(e)}
                                    />

                                    {minLicencas > 0 && (
                                        <small>Mínimo: {minLicencas} (em uso)</small>
                                    )}

                                    {/* Detalha de onde vem o mínimo acima - os dois contadores que o
                                        backend valida (ver editUser em plans.service.ts), já que cada
                                        um pode ser o responsável pelo mínimo dependendo da conta. */}
                                    <small>Responsá{agronomosEmUso === 1 ? 'vel técnico' : 'veis técnicos'} ({agronomosEmUso}/{qtdAtual})</small>
                                    <small>Usuário{usuariosEmUso === 1 ? '' : 's'} ({usuariosEmUso}/{qtdAtual})</small>
                                </NumericBoxWrapper>

                                <DeltaValue>
                                    {simulando ? '...' : deltaTexto}
                                </DeltaValue>
                            </CompareRow>

                            <CompareRow total>
                                <CompareLabel bold>
                                    {qtdNova} {qtdNova === 1 ? 'licença' : 'licenças'} no total
                                </CompareLabel>

                                <DeltaQty>
                                    {deltaQtd > 0 ? `+${deltaQtd}` : deltaQtd}
                                </DeltaQty>

                                <DeltaValue />
                            </CompareRow>
                        </CompareTable>

                        <NewValueSummary>
                            {simulacao
                                ? (deltaQtd === 0
                                    ? `Valor atual: ${formatBRL(simulacao.valor_atual)}${sufixoCiclo}`
                                    : `Novo valor: ${formatBRL(simulacao.valor_novo)}${sufixoCiclo}`)
                                : erroSimulacao || 'Calculando novo valor...'}
                        </NewValueSummary>

                        <ProrationNote>
                            Eventuais créditos proporcionais ao tempo não utilizado no ciclo atual serão aplicados automaticamente na etapa seguinte.
                        </ProrationNote>

                        <ModalButtonsRow>
                            <Button
                                width='160px'
                                height='48px'
                                value='CANCELAR'
                                loading={false}
                                outline={true}
                                color={theme.colors.gray.Cinza_2}
                                disabled={false}
                                onClick={() => setShowNewUser(false)}
                            />

                            <Button
                                width='200px'
                                height='48px'
                                value='CONFIRMAR'
                                loading={loading}
                                outline={false}
                                disabled={simulando || !simulacao || deltaQtd === 0 || qtdNova < minLicencas}
                                tooltip={true}
                                tooltipMsg={
                                    qtdNova < minLicencas
                                        ? `Você tem ${minLicencas} responsável(is) técnico(s) em uso - não é possível reduzir abaixo disso`
                                        : deltaQtd === 0
                                            ? 'Ajuste a quantidade de licenças para confirmar'
                                            : ''
                                }
                                onClick={() => update()}
                            />
                        </ModalButtonsRow>
                    </ModalStack>
                </ModalWide>
            </ModalGeneric>

            <ModalGeneric
                show={showNoUpdate}
                onHide={() => setShowNoUpdate(false)}
                size='md'
            >
                <Container marginTop="0px">
                    <Title>Atenção!</Title>
                    
                    <p className='text'>Não é possível a inclusão de mais usuários no plano <b>{plano?.plans?.plan_name === "PLANO PRÉ-PAGO" ? 'PRÉ-PAGO' : plano?.plans?.plan_name === 'PLANO BASIC' ? 'BASIC' : plano?.plans?.plan_name}</b>!</p>
                    <p className='text'>Faça um upgrade para os planos Light ou Pro e inclua mais usuários. </p>
                    <p className='text'>Utilize o cupom <b>+LICENCAS</b> e garanta 10% de desconto na mensalidade! </p>

                    <Button 
                        width='200px'
                        height='50px'
                        margin='16px 0px'
                        value='ATUALIZAR PLANO'
                        loading={false}
                        outline={false}
                        disabled={false}
                        onClick={() => window.location = '/planos'}
                    />
                </Container>
            </ModalGeneric>
        </>
    )
}

export default withRouter(EditarPlano);